import React, { Component } from 'react';
import PropTypes, { bool } from 'prop-types';
import { injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import { ResponsiveImage, IconSpinner } from '../../components';
import { propTypes } from '../../util/types';

import css from './ImageSlider.css';
import Slider from 'react-slick';

class ImageSlider extends Component {
	constructor(props) {
		super(props);
		this.state = { selectedImageIndex: 0, selectedImageLoaded: false };
		this.onImageSwiped = this.onImageSwiped.bind(this);
	}

	onImageSwiped(index) {
		this.setState({ selectedImageIndex: index });
	}

  render() {
    const { rootClassName, className, images, intl, useDots, useArrows } = this.props;
    const classes = classNames(rootClassName || css.root, className, {
      [css.useDotsContainerClassName]: useDots,
      [css.useArrowsContainerClassName]: useArrows,
    });

		const naturalIndex = this.state.selectedImageIndex + 1;
		const imageIndex =
			images.length > 0 ? (
				<span className={css.imageIndex}>
					{naturalIndex}/{images.length}
				</span>
			) : null;

		const imageAltText = intl.formatMessage(
			{
				id: 'ImageCarousel.imageAltText',
			},
			{
				index: naturalIndex,
				count: images.length,
			}
		);

		const currentImageIsLoaded = images.length !== 0;
		const loadingIconClasses = classNames(css.loading, {
			[css.loadingVisible]: !currentImageIsLoaded,
		});
		const imageClasses = classNames(css.image, {
			[css.imageLoading]: !currentImageIsLoaded,
		});

		const settings = {
      dots: useDots,
      arrows: useArrows,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			accessibility: false,
			className: css.imageSlider,
			afterChange: this.onImageSwiped,
		};

		return (
			<div className={classes}>
				<Slider {...settings}>
					{images.map(image => {
						return <div className={css.imageWrapper} key={image.id.uuid}>
							<IconSpinner className={loadingIconClasses} />
							<ResponsiveImage
								className={imageClasses}
								alt={imageAltText}
								image={image}
								variants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
								sizes="(max-width: 767px) 100vw, 80vw"
							/>
						</div>
					})}
				</Slider>
				{imageIndex}
			</div>
		);
	}
}

ImageSlider.defaultProps = {
	rootClassName: null,
	className: null,
  useDots: false,
  useArrows: false,
};

const { string, arrayOf } = PropTypes;

ImageSlider.propTypes = {
	rootClassName: string,
	className: string,
	images: arrayOf(propTypes.image).isRequired,
  useDots: bool,
  useArrows: bool,

	// from injectIntl
	intl: intlShape.isRequired,
};

export default injectIntl(ImageSlider);
